import type { StaticMessageId } from './ids';

// A route handle is a module-scope object evaluated before any provider mounts, so it cannot call
// msg(). It carries a reference instead, and the consumer (Breadcrumbs, DocumentTitle) resolves it
// during render. Only static ids qualify: a handle has no values to hand a placeholder.
export interface MessageRef<K extends StaticMessageId = StaticMessageId> {
  readonly messageId: K;
}

export function messageRef<K extends StaticMessageId>(messageId: K): MessageRef<K> {
  return { messageId };
}

export function isMessageRef(value: unknown): value is MessageRef {
  return (
    typeof value === 'object' &&
    value !== null &&
    'messageId' in value &&
    typeof (value as { messageId: unknown }).messageId === 'string'
  );
}
